// extracted by mini-css-extract-plugin
module.exports = {"phone":"styles_phone__1Zx1I","bgNavbar":"styles_bgNavbar__1ijt5","navlink":"styles_navlink__31q6b","logo":"styles_logo__1d-Qb"};